/**
 * Check if the resolution is for a tablet.
 * @returns {boolean} True if the resolution is tablet, false otherwise.
 */
function isTablet() {
    return window.matchMedia("(min-width: 600px) and (max-width: 991px)").matches;
}

/**
 * Check if the resolution is for a mobile device.
 * @returns {boolean} True if the resolution is mobile, false otherwise.
 */
function isMobile() {
    return window.matchMedia("(max-width: 599px)").matches;
}

$(document).ready(function() {
    var isTabletScreen = isTablet()
    if (isTabletScreen) {
        $('.row.screen-size').children().slice(-4).addClass('d-none');
    } else {
        $('.row.screen-size').children().removeClass('d-none');
    }
    
    $(window).resize(function() {
        if (isTablet()) {
            $('.row.screen-size').children().slice(-4).addClass('d-none');
        } else {
            $('.row.screen-size').children().removeClass('d-none');
        }
    });
});
